import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["viewDetails", "hideDetails", "contentWrapper"];
  isOpen = false;

  toggleAccordion() {
    const viewDetailsButton = this.viewDetailsTarget;
    const hideDetailsButton = this.hideDetailsTarget;
    const wrapper = this.contentWrapperTarget;

    if (!viewDetailsButton || !hideDetailsButton || !wrapper) {
      console.error("Missing Stimulus targets");
      return;
    }

    if (this.isOpen) {
      // COLLAPSE
      wrapper.style.height = wrapper.scrollHeight + "px"; // Set current height first
      requestAnimationFrame(() => {
        wrapper.style.height = "0px";
        wrapper.classList.remove("open");
        wrapper.classList.add("closed");
      });

      viewDetailsButton.style.display = "grid";
      hideDetailsButton.style.display = "none";
    } else {
      // EXPAND
      wrapper.classList.remove("closed");
      wrapper.classList.add("open");

      const fullHeight = wrapper.scrollHeight;
      wrapper.style.height = fullHeight + "px";

      // Optional: set to auto after transition ends to allow content growth
      wrapper.addEventListener(
        "transitionend",
        () => {
          if (this.isOpen) {
            wrapper.style.height = "auto";
          }
        },
        { once: true }
      );

      viewDetailsButton.style.display = "none";
      hideDetailsButton.style.display = "grid";
    }

    this.isOpen = !this.isOpen;
  }
}
